angular.module(NgAppName).directive("crFieldPhoneNumber", ["$filter", function($filter) {
	return {
		restrict: "A", // only activate on element attribute
		require: "?ngModel", // get a hold of NgModelController
		scope: {
			lastKeyPressed: "<"
		},
		link: function(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return; // do nothing if no ng-model
			}

			var currentCursorPosition;
			var oldValue = "";

			var formatter = function(value) {
				value = (typeof(value) === "undefined" || value == null) ? "" : value;
				value = value.replace(/[^\d\s\-()+,ex]/gi, "");
				var match = value.match(/^(\+[\d-]*)?([()\d\s-]*)?([ex,\s]*\d*)?$/);
				var code = "", phone = "", extension = "";

				if (match !== null && match.length >= 4) {
					code      = (typeof(match[1]) !== "undefined") ? match[1].replace(/-+/g, "-").replace(/[^\d-]/g, "") : null;
					phone     = (typeof(match[2]) !== "undefined") ? match[2].replace(/[^\d]/g, "") : null;
					extension = (typeof(match[3]) !== "undefined") ? match[3].replace(/[^\d]/g, "") : null;

					if (phone !== null) {
						var parts = [
							phone.slice(0, 3),
							phone.slice(3, 6),
							phone.slice(6)
						].filter(Boolean);

						phone = "";
						if (parts.length > 1) {
							phone = "(" + parts.shift() + ") " + parts.join("-");
						} else {
							phone = parts.join("-");
						}
					}

					// backspace or delete pressed while extension prefix exists but empty => remove extension prefix
					if (extension === "" && wasSymbolDeleted()) {
						extension = null;
					}

					value =
						(code      !== null ? ("+" + code) : "") +
						(phone     !== null ? (" " + phone) : "") +
						(extension !== null ? (" ext " + extension) : "")
					;

					return value.trimStart();
				} else {
					return null;
				}
			};

			var parser = function(value) {
				var tmpValue = value;

				value = formatter(value);

				var formattingWasAdded = (tmpValue !== value);

				if (formattingWasAdded) {
					saveCursorPosition(tmpValue, element[0].selectionStart)
				}

				if (value === null) {
					value = oldValue;
				} else {
					oldValue = value;
				}

				ngModel.$setViewValue(value);
				ngModel.$render();

				if (formattingWasAdded) {
					element[0].selectionStart = element[0].selectionEnd = restoreCursorPosition(value);
				}

				return value;
			};

			var saveCursorPosition = function(value, cursorPosition) {
				// calculating cursor position based on numbers only
				currentCursorPosition = 0;
				for(var i = 0; i < cursorPosition; i++) {
					var charCode = value.charCodeAt(i);
					if (charCode >= 48 && charCode <= 57) { // any number (0-9)
						currentCursorPosition++;
					}
				}
			};

			var restoreCursorPosition = function(value) {
				var i = 0;
				var tmp = wasSymbolDeleted() ? currentCursorPosition : currentCursorPosition;

				while (tmp > 0 && i < value.length) {
					var charCode = value.charCodeAt(i);
					if (charCode >= 48 && charCode <= 57) { // any number (0-9)
						tmp--;
					}
					i++;
				}
				return i;
			};

			var wasSymbolDeleted = function() {
				return [8, 46].indexOf(scope.lastKeyPressed) !== -1;
			};

			ngModel.$parsers.push(parser);
			ngModel.$formatters.push(formatter);
		}
	};
}]);

